import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { config } from '../../../config';

@Injectable()
export class PasswordService {
  constructor(private http: HttpClient) {}

  /**
   * Request a password reset email
   *
   * @param {string} email
   */
  requestReset(email: string) {
    return this.http.post(`${config.apiLocation}/auth/password/email`, { email });
  }

  /**
   * Attempt to reset a password
   *
   * @param {string} token
   * @param {string} email
   * @param {string} password
   * @param {string} password_confirmation
   */
  reset(
    token: string,
    email: string,
    password: string,
    password_confirmation: string,
  ) {
    return this.http.post(`${config.apiLocation}/auth/password/reset`, { token, email, password, password_confirmation });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/password.service.ts